<div [matTooltip]="this.tooltip ?? undefined" matRipple matRippleColor="rgba(255,255,255,0.15)" class="gantt-bar" [ngClass]="colorClass" [ngStyle]="{
  'left': start,
  'width': width,
  'background-color': colorOverride ?? undefined
}">&nbsp;</div>
